import React from 'react'
import { Badge, Button } from 'element-react'

const BadgeSG = () => {
    return (
        <ul className="inline-list padding-small">
            <li>
                <Badge value={200} max={99}>
                    <Button size="small">Comments</Button>
                </Badge>
            </li>
            <li>
                <Badge value={100} max={10}>
                    <Button size="small">Replies</Button>
                </Badge>
            </li>
        </ul>
    )
}

export default BadgeSG
